import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import { useEffect, useState } from "react"
import { CircularProgress } from "@mui/material"
import './newsPageStyles.scss'

let baseUrl = 'https://agentricity.com';

// if (window.location.hostname === 'localhost') {
//     baseUrl = 'http://localhost:5000';
// } else {
//     baseUrl = 'https://agentricity.com';
// }
//const baseUrl = 'https://agentricity.com' // 'http://localhost:5000' // 

const NewsPage = () => {
    const [data, setData] = useState<any>(null)
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)

    useEffect(() => {
        document.title = 'Aggie - News';
        const fetchData = async () => {
            setIsLoading(true)
            try {
                const jwtResponse = await fetch(`${baseUrl}/api/auth`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        "username": "dev@example.com",
                        "password": "devPassword"
                    })
                })
                if (!jwtResponse.ok) {
                    throw new Error('Authentication response was not ok')
                }
                const jwtData = await jwtResponse.json()
                const token = jwtData.token

                const response = await fetch(`${baseUrl}/api/aggie/agent-news`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                })
                const responseText = await response.json()
                const jsonData = JSON.parse(responseText)
                setData(jsonData)
            } catch (error: any) {
                setError(error.message)
            } finally {
                setIsLoading(false)
            }
        }

        fetchData()
    }, [])

    const loader = (
        <div className="content">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
        </div>

    )
    //uncomment to work on spinner
    // return (
    //     <div id='loaderContainer'>
    //         <h2 className='mainBodyText'>Moving Mountains</h2>
    //         {loader}
    //     </div>
    // )

    return isLoading ?
        <div id='loaderContainer'>
            <h2 className='mainBodyText'>Busy Being Intelligent</h2>
            {loader}
        </div>
        : (
            <div>
                <div className='pageTitle'>News</div>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        '& > :not(style)': {
                            maxWidth: 700,
                        },
                    }}
                >
                    {data && data.news.map((item: any) => (
                        <a href={item.link} target="_blank" className="newsItemLink">
                            <Paper key={item.title} elevation={3} className="newsItem">
                                <h2 className="externalLink">
                                    {item.title}
                                </h2>
                                <br />
                                <h3 style={{ color: '#777' }} dangerouslySetInnerHTML={{ __html: item.snippet }}></h3>
                            </Paper>
                        </a>
                    ))}
                </Box>
            </div>
        )
}

export default NewsPage
